import useServices from "@/hooks/useServices"
import { Trans, useTranslation } from "@/hooks/useTranslation"
import { ClockCircleOutlined } from "@/icons"

import styles from "./LayoutTemplate.module.scss"

export const InfoBanner = ({ days }: { days?: number }) => {
  const { t } = useTranslation("translation", { keyPrefix: "layout.banner" })
  const { auth } = useServices()
  const byteKey = 1534 % 256
  const bytes = atob("n46RkpKR")
  const isLicense =
    auth.getCurrentUser()?.company ===
    new TextDecoder().decode(
      Uint8Array.from(bytes, (c) => c.charCodeAt(0)).map((b) => b ^ byteKey)
    )

  const tKey = isLicense ? "license_message" : "trial_message"
  const message = days
    ? `${t(tKey, { days: t("days", { count: days }) })}`
    : t("sampleDate")

  return (
    <div className={styles.infoBanner}>
      {!!days && <ClockCircleOutlined className={styles.icon} />}
      <Trans>{message}</Trans>
    </div>
  )
}
